import $ from "jquery";
import anime from 'animejs';
import utils from "./utils";
import Timer from "@alpaga/timer";
const TimeLineOptions = {
    "top-to-bottom": {
        height: "100%"
    },
    "bottom-to-top": {
        height: "100%",
        marginTop: "0%"
    },
    "left-to-right": {
        width: "100%"
    },
    "center-to-side": {
        width: "100%",
        marginLeft: "0%",
        marginRight: "0%"
    },
    "center-to-top": {
        height: "100%",
        marginTop: "0%",
        marginBottom: "0%"
    },
    "right-to-left": {
        width: "100%",
        marginLeft: "0%"
    },
    "all": {
        width: "100%",
        height: "100%",
        marginTop: "0%"
    }
};
$(document).ready(() => {
    $(window).on("scroll", utils.debounce((e) => {
        utils.isInViewportCollection('.custom-slider:not(.revealed)', (elm) => {
            let $customSlider = $(elm);
            $customSlider.addClass("revealed");
            const slider = new Timer(() => {
                $customSlider.attr("data-step", parseInt($customSlider.attr("data-step")) == 1 ? "2" : "1");
            }, parseInt($customSlider.attr("data-speed")));
            $customSlider.hover(() => { slider.stop(); }, () => { slider.start(); });
            $customSlider.on("click", ".bullets span", (e) => {
                $customSlider.attr("data-step", $(e.currentTarget).index() + 1);
                slider.stop().start();
            });
        });
        utils.isInViewportCollection('.reveal-item:not(.revealed)', (elm) => {
            $(elm).addClass("revealed");
        });
        utils.isInViewportCollection('.revealer:not(.revealed)', (elm) => {
            $(elm).addClass("revealed");
            // let options = {};
            // if ($(elm).attr("data-reveal") !== void 0) {
            //     options = TimeLineOptions[$(elm).attr("data-reveal")];
            // } else {
            //     options = TimeLineOptions["left-to-right"];
            // }
            // let delay = 0;
            // if ($(elm).attr("data-reveal-delay") !== void 0) {
            //     delay = parseInt($(elm).attr("data-reveal-delay"));
            // }
            // var tl = anime.timeline({
            //     easing: 'easeInOutExpo',
            //     duration: 450,
            //     delay: delay
            // });
            // let target1 = Object.assign({}, options);
            // target1["targets"] = elm.querySelector('.mask-reveal');
            // //
            // let target2 = Object.assign({}, options);
            // target2["targets"] = elm.querySelector('.content-reveal');
            // tl
            //     .add(target1)
            //     .add(target2, "-=200")
            // ;
        });
    }, 50)).trigger("scroll");
    class MorphingBG {
        constructor(el) {
            this.DOM = {};
            this.DOM.el = el;
            this.DOM.paths = Array.from(this.DOM.el.querySelectorAll('path'));
            this.animate();
        }
        animate() {
            this.DOM.paths.forEach((path) => {
                anime({
                    targets: path,
                    duration: 20000,
                    // easing: [0.5,0,0.5,1],
                    d: path.getAttribute('pathdata:id'),
                    loop: true,
                    direction: 'alternate'
                });
            });
        }
    }
    ;
    if ($('svg.scene').length) {
        new MorphingBG(document.querySelector('svg.scene'));
    }
});
